import React from "react";
import { format, parseISO } from "date-fns";
import { useState } from "react";
import MaterialTable from "material-table";
import usePhysicalInventorySubmissions from "../helper/usePhysicalInventorySubmissions";
import useAuthUser from "../../base/helper/useAuthUser";
import { ListAlt, MoneyOff } from "@material-ui/icons";
import GeneratePICostReport from "./GeneratePICostReport";
import PIMissingPriceItems from "./PIMissingPriceItems";

function PhysicalInventorySubmissions({ fromDate, toDate }) {
  const { storeId } = useAuthUser();

  const {
    submissions,
    isLoading: loadingSubmissions,
  } = usePhysicalInventorySubmissions(storeId, fromDate, toDate);

  const [selectedDate, setSelectedDate] = useState(null);
  const [missingPricesSelectedDate, setMissingPricesSelectedDate] = useState(
    null
  );

  return (
    <>
      <MaterialTable
        title={"Inventory Submissions"}
        data={submissions}
        isLoading={loadingSubmissions}
        columns={[
          {
            title: "Date",
            field: "createdat",
            render: (row) => {
              return format(parseISO(row.createdat), "MM-dd-yyyy");
            },
          },
        ]}
        options={{
          paging: true,
          pageSize: 25,
          pageSizeOptions: [25, 50, 100, 250, 500],
          actionsColumnIndex: 3,
        }}
        actions={[
          {
            icon: () => <MoneyOff />,
            tooltip: "Get Product list with missing prices",
            onClick: (event, data) =>
              setMissingPricesSelectedDate(parseISO(data.createdat)),
            position: "row",
          },
          {
            icon: () => <ListAlt />,
            tooltip: "Generate Report",
            onClick: (event, data) => setSelectedDate(data.createdat),
            position: "row",
          },
        ]}
      />
      {selectedDate && (
        <GeneratePICostReport
          open={selectedDate !== null}
          selectedDate={selectedDate}
          onClose={() => {
            setSelectedDate(null);
          }}
        />
      )}
      {missingPricesSelectedDate && (
        <PIMissingPriceItems
          handleClose={() => {
            setMissingPricesSelectedDate(null);
          }}
          date={missingPricesSelectedDate}
        />
      )}
    </>
  );
}

export default PhysicalInventorySubmissions;
